/* import __COLOCATED_TEMPLATE__ from './customer.hbs'; */
/* RESPONSIBLE TEAM: team-data-foundations */
import Component from '@glimmer/component';
import type { ShopifyCustomer } from '../shopify';
import { inject as service } from '@ember/service';
import type Session from 'embercom/services/session';

interface Signature {
  Args: {
    shopifyCustomer: ShopifyCustomer;
    userShopifyDomain?: string;
    isExpanded?: boolean;
    toggleExpandCustomer?: () => void;
    setShowAllOrders?: () => void;
    shopifyCustomerOrdersUrl?: string;
    hasOrders?: boolean;
  };
}
export default class Inbox2Customer extends Component<Signature> {
  @service declare session: Session;

  get canUseShopifyMultiStore() {
    return this.session.workspace.isFeatureEnabled('shopify-multi-store');
  }

  get userShopifyStoreName() {
    return this.args.userShopifyDomain?.split('.')[0] ?? '';
  }
}

declare module '@glint/environment-ember-loose/registry' {
  export default interface Registry {
    'Inbox2::ConversationDetailsSidebar::SidebarSections::Shopify::Customer': typeof Inbox2Customer;
    'inbox2/conversation-details-sidebar/sidebar-sections/shopify/customer': typeof Inbox2Customer;
  }
}
